export class IdValue {

  public id: string;
  public text: string;

}
